import { WorkoutType } from '../../config';
import { CardioOrResistance } from '../../entities';

export interface IPointInTimeInfo {
  name: string;
  initial: string;
  effortPoints: string | number;
  isBot: boolean;
  workoutId: string;
  userProfileId: string;
  lastActiveSecond?: string;
  cardioOrResistance: CardioOrResistance;
}

export interface IPointInTimeLeaderboard {
  [key: number]: IPointInTimeInfo[];
}

export class HomeGroupClass {
  public static calculateReferenceNumber(
    groupCallPairedId: string,
    workoutType: WorkoutType,
  ): string {
    return `${groupCallPairedId}-${workoutType}`;
  }

  public static clone(instance: HomeGroupClass): HomeGroupClass {
    const copy = new HomeGroupClass();
    Object.assign(copy, JSON.parse(JSON.stringify(instance)));
    return copy;
  }

  public pointInTimeLeaderboard: IPointInTimeLeaderboard = {};
  public createdAt: Date;

  constructor() {
    this.createdAt = new Date();
  }

  public addPointInTimeToLeaderboard(key: string, pointInTimeInfo: IPointInTimeInfo, botWorkoutIdToRemove?: string) {
    if (!this.pointInTimeLeaderboard[key]) {
      this.pointInTimeLeaderboard[key] = [];
    }

    if (botWorkoutIdToRemove) {
      const indexToRemove = this.pointInTimeLeaderboard[key]
        .findIndex(({ workoutId }: IPointInTimeInfo) => workoutId === botWorkoutIdToRemove);
      this.pointInTimeLeaderboard[key].splice(indexToRemove, 1);
    }

    const existingIndex = this.pointInTimeLeaderboard[key]
      .findIndex(({ workoutId, userProfileId, isBot }: IPointInTimeInfo) =>
        (workoutId === pointInTimeInfo.workoutId ||
          userProfileId === pointInTimeInfo.userProfileId) && !isBot);

    if (existingIndex > -1) {
      this.pointInTimeLeaderboard[key][existingIndex] = pointInTimeInfo;
    } else {
      this.pointInTimeLeaderboard[key].push(pointInTimeInfo);
    }
  }

  public removeAllBots() {
    Object.keys(this.pointInTimeLeaderboard).forEach((key: string) => {
      this.pointInTimeLeaderboard[key]
        = this.pointInTimeLeaderboard[key].filter((pointInTimeInfo: IPointInTimeInfo) => !pointInTimeInfo.isBot);
    });
  }
}
